import { Button, Stack } from "@mui/material";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import * as z from "zod";

import { useCreateNotificationHandlerNotificationHandlersPostMutation } from "api";
import { TextInput } from "components/forms";
import { INotificationHandlerSkyresponse } from "interfaces/notification.interface";

const skyresponseHandlerSchema = z.object({
  description: z.string(),
});

type SkyresponseHandlerSchema = z.infer<typeof skyresponseHandlerSchema>;

type TempSkyresponseProps = {
  disabled: boolean;
  zoneId: string;
  onClose: () => void;
  defaultValues: INotificationHandlerSkyresponse | null;
};

export function TempSkyresponse({
  disabled,
  zoneId,
  onClose,
  defaultValues,
}: TempSkyresponseProps) {
  const { t } = useTranslation();

  const [createHandler] =
    useCreateNotificationHandlerNotificationHandlersPostMutation();

  const { control, handleSubmit } = useForm<SkyresponseHandlerSchema>({
    resolver: zodResolver(skyresponseHandlerSchema),
    defaultValues: defaultValues ?? {},
  });

  const onCreate = async (data: SkyresponseHandlerSchema) => {
    await createHandler({
      notificationHandlerCreate: {
        type: "skyresponse",
        zone_id: zoneId,
        enabled: true,
        description: data.description,
        configuration: {},
      },
    });

    onClose();
  };

  return (
    <Stack
      component={"form"}
      onSubmit={handleSubmit(onCreate)}
      sx={{
        gap: 1,
      }}
    >
      <TextInput
        fieldName={"description"}
        control={control}
        label={t("Description")}
        placeholder={t(
          "notification_skyresponse_handler_description_placeholder",
        )}
        disabled={disabled}
        required
      />
      <Stack
        direction={"row"}
        sx={{
          gap: 2,
        }}
      >
        {!defaultValues && <Button type={"submit"}>{t("Create")}</Button>}
        <Button variant={"text"} onClick={onClose}>
          {t("Cancel")}
        </Button>
      </Stack>
    </Stack>
  );
}
